/* eslint-disable */

import { Link, useLocation, useNavigate } from "react-router-dom";
import { Orientation } from "../../logic/enums.ts";
import WrapperDoubleClickable from "../wrapper-double-clickable/wrapper-double-clickable.tsx";

const TabIndicator = () => {
  return (
    <div id="indicator" className={"absolute flex h-2 w-2 translate-x-2 "}>
      <div
        className={
          "animate-ping absolute inline-flex h-full w-full rounded-full bg-color-raindrop-primary opacity-75"
        }
      />
      <div
        className={
          "relative inline-flex rounded-full h-2 w-2 bg-color-raindrop-primary opacity-80"
        }
      />
    </div>
  );
};

const TabOption = ({
  icon = "fa-search",
  text = "Search",
  to = "/",
  onClick = () => {},
  onDoubleClick = () => {},
  isSelected = false,
  showIndicator = false,
  orientation = Orientation.Portrait,
}) => {
  let fillColor = "fill-color-raindrop-minor";
  let strokeColor = "stroke-color-raindrop-minor";
  let textColor = "text-color-dark-text-secondary";

  let opacityClass = "opacity-80";
  let scaleClass = "scale-90";
  let rotateClass = "rotate-0";

  if (isSelected) {
    fillColor = "fill-color-raindrop-primary";
    strokeColor = "stroke-color-raindrop-primary";
    opacityClass = "opacity-100";
    // textColor = "text-color-raindrop-primary";
    scaleClass = "scale-100";
    // rotateClass =
    // orientation === Orientation.Portrait ? "rotate-6" : "rotate-0";
    switch (text) {
      case "Home":
        textColor = "text-blue-500";
        break;
      case "Contribution":
        textColor = "text-purple-500";
        break;
      case "Search":
        textColor = "text-cyan-600";
        break;
      case "Profile":
        textColor = "text-green-500";
        break;
      case "Waterfall":
        textColor = "text-blue-500";
        break;
      case "Notifications":
        textColor = "text-yellow-500";
        break;
      case "Settings":
        textColor = "text-gray-500";
        break;
      default:
        textColor = "text-gray-500";
        break;
    }
  }

  return (
    <WrapperDoubleClickable onDoubleClick={onDoubleClick}>
      <Link
        to={to}
        className={`flex flex-col justify-center gap-1 items-start gap-1/2 relative transition-all pt-2   `}
        onClick={onClick}
      >
        <div
          id="hello"
          className={`flex flex-row items-center gap-4 ${opacityClass} ${scaleClass} transition-all duration-200 ease-in-out ${rotateClass} `}
        >
          <div className="flex flex-col items-center">
            <i
              className={`fa ${icon} text-3xl font-black ${textColor} ${strokeColor} ${fillColor} `}
            />
            {showIndicator && <TabIndicator />}
          </div>
        </div>
      </Link>
    </WrapperDoubleClickable>
  );
};

const RaindropTabBar = ({
  userCurrent,
  onResetCircle = () => {},
  showIndicatorOnSearch = false,
}) => {
  const pathname = useLocation().pathname;
  const navigate = useNavigate();

  const urlProfile = `/raindrop/account/${userCurrent?.account.id}`;

  const isAnonymous = userCurrent === null;

  let flexDirection = "flex-row";
  let bottomPadding = "pb-10";
  let gap = "justify-evenly";
  let widthClass = "w-full";
  let heightClass = "h-fit";

  let waterfallUrl = "/raindrop/waterfall-create";
  if (userCurrent?.account?.primaryWaterfall) {
    waterfallUrl = `/raindrop/waterfall/${userCurrent.account.primaryWaterfall.id}`;
  }

  return (
    <div
      className={`flex ${flexDirection} ${widthClass} ${gap} ${bottomPadding} ${heightClass} justify-center  pointer-events-auto border-t-2 pt-2 dark:border-none`}
    >
      <div
        className={
          "absolute w-full h-full dark:bg-color-dark-background-primary opacity-90 backdrop-blur-3xl "
        }
      />

      {!isAnonymous && (
        <TabOption
          to={urlProfile}
          icon={"fa-user"}
          showIndicator={showIndicatorOnSearch}
          text={"Profile"}
          isSelected={pathname === urlProfile}
        />
      )}
      <TabOption
        to={"/raindrop/search"}
        icon={"fa-search"}
        showIndicator={showIndicatorOnSearch}
        text={"Search"}
        onDoubleClick={() => {
          navigate("/raindrop/pomodoro");
        }}
        isSelected={pathname === "/raindrop/search"}
      />
      <TabOption
        to={"/raindrop/activity"}
        icon={"fa-home"}
        text={"Home"}
        isSelected={pathname === "/raindrop/activity"}
        onDoubleClick={() => {
          navigate("/raindrop/tour");
        }}
      />
      <TabOption
        to={"/raindrop/contribution"}
        icon={"fa-pie-chart"}
        text={"Contribution"}
        // onClick={onResetCircle}
        onDoubleClick={() => {
          navigate("/raindrop/meditate");
        }}
        isSelected={pathname === "/raindrop/contribution"}
      />
      <TabOption
        to={waterfallUrl}
        icon={"fa-droplet"}
        showIndicator={showIndicatorOnSearch}
        text={"Waterfall"}
        isSelected={pathname.startsWith("/raindrop/waterfall")}
        onDoubleClick={() => {
          navigate("/raindrop/bombshell");
        }}
      />
    </div>
  );
};

export default RaindropTabBar;
